<template>
    <div id="content" class="flex ">
        <!-- ############ Main START-->
        <div>
            <div class="page-hero page-container " id="page-hero">
                <div class="padding pb-0">        
                    <h1 class="text-md text-highlight mb-0 pb-0">Personas</h1>
                    <hr>
                </div>           
            </div>
        </div>
        <div class="page-content page-container" id="page-content">
            <div class="padding">
                <ul v-if="personas.length" id="accordion" class="accordion">
                    <li v-for="(persona, index) in personas" :key="'persona-'+index">
                        <div class="d-flex link align-items-center">
                            <!--<chevron-down-icon class="custom-class" width="16" height="16"></chevron-down-icon>-->
                            Related to {{persona.source_company_domain}} <span v-if="persona.order"> - {{persona.order}}</span>
                            <button class="btn btn-raised btn-wave indigo pl-4 pr-4 ml-auto mr-2"
                                @click="loadResults(persona.source_company_id, persona.recommendations_ids, index)">
                                View Report
                            </button>
                        </div>
                        <RecommendationList v-if="active==index"
                                            :source="source_company"
                                            :recommendations="recommendations"
                                            :currentPage="currentPage"
                                            :persona_id="persona.id"
                                            routedFrom="personas">
                          </RecommendationList>
                        <!--
                        <div class="submenu">
                                <div class="grid-template">
                                    <div><small>2 days ago</small></div>
                                    <div>
                                        <ul>
                                            <li>Report 3</li>
                                            <li>10 Websites</li>
                                            <li><a href="#"><i class="mr-1" data-feather="info"></i> 110.7K more results available</a></li>
                                        </ul>
                                    </div>
                                    <div>
                                        <button class="btn btn-light"><i class="mr-2" data-feather="trending-up"></i> Monthly Visits</button>
                                        <div class="text-success mt-2"><i class="mr-2 ml-2" data-feather="check-circle"></i>  + 100K - 6M</div>
                                    </div>
                                    <div>
                                        <button class="btn btn-raised btn-wave indigo pl-4 pr-4">View Report</button>
                                    </div>
                                </div>
                        </div>-->
                    </li>
                </ul>
                <div v-else class="alert alert-danger show p-3" role="alert">
                    You have not saved any personas yet.
                </div>                  
            </div>
        </div>
    </div>
</template>


<script type="text/javascript">
import { ChevronDownIcon, ChevronUpIcon} from 'vue-feather-icons'
import {getUser} from '@/utils/auth';
import RecommendationList from '@/components/RecommendationList';

export default{
    name: 'Persona',
    components: {
        ChevronDownIcon,
        ChevronUpIcon,
        RecommendationList
    },
    data() {
        return {
            user_email: '',
            personas: [],
            active: -1,
            source_company: {},
            recommendations: [],
            currentPage: 1,
        }; 
    },
    activated(){
        getUser().then(response =>{
               var user = response.data;
               this.user_email = user['email'];
        })
        .catch(error => {
               console.log(error)
        })
        const path = process.env.API_LOCATION + `/get_personas`;

        var that = this;
        this.$http.get(path)
            .then((res) => {
                that.personas = res.data.personas;
                console.log("Personas loaded successfully.");
                console.log(res);
                var order = 1;
                for (var i = 0; i < that.personas.length-1; i++) {
                    if(that.personas[i].source_company_domain===that.personas[i+1].source_company_domain){
                        that.personas[i].order = order;
                        order++;
                    }
                    else{
                        if(order!=1){
                            that.personas[i].order = order;
                        }
                        order=1;
                    }
                }
                if(order!=1){
                    that.personas[i].order = order;
                }
            })
            .catch((error) => {
                console.log("Error while loading company profile.");
                console.error(error);
            });
    },
    methods: {
        loadResults(source_id, rec_ids, index){
            if(this.active==index) {
                this.active = -1;
                return;
            }

            const path = process.env.API_LOCATION + `/company_profiles`;
            var that = this;
            this.$http.get(path, {params: {ids: rec_ids}})
                .then((res) => {
                    that.recommendations = res.data.companies;
                    for (var i = that.recommendations.length - 1; i >= 0; i--) {
                        that.recommendations[i]['rank'] = i+1;
                    }
                    this.active = index;
                })
                .catch((error) => {
                    console.log("Error while loading company profile.");
                    console.error(error);
            });
        },
    },
};  

</script>



// WEBPACK FOOTER //
// src/components/Persona.vue